import styled from "styled-components"

interface WrapperProps {
  withMarginTop?: boolean
}
export const Wrapper = styled.div<WrapperProps>`
  ${({withMarginTop}) => withMarginTop && "margin-top: 25vh;"}
`

export const Img = styled.img`
  width: 181px;
  margin-bottom: 30px;
`
